<div class="page">
  <div class="page__container">
    <h1 class="page__title  h2" translate>shop_cart_title_billing</h1>
    <wsb-atlas-step class="mb-4" [numSteps]="2" [currentStep]="currentStep" [routeStep]="routeStep"></wsb-atlas-step>

    <div class="my-5">
      <p translate class="my-5">shop_cart_title_billing_compile</p>
      <form *ngIf="billingForm" [formGroup]="billingForm">
        <div formGroupName="billing">
          <!--                <h3 class="my-5" translate>settings_edit_billing_title</h3>-->
          <div class="page__form-wrap">
            <div *ngIf="!isPrivateUser" class="form-group row">
              <label for="companyName" class="col-sm-4" translate>account_company</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="companyName"
                  formControlName="companyName"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.companyName')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.companyName')"></wsb-validation-error-msg>
              </div>
            </div>
            <div *ngIf="!isPrivateUser" class="form-group row">
              <label for="vatCode" class="col-sm-4" translate>account_piva</label>
              <div class="col-sm-8">
                <input
                  [readonly]="user.account.isCustomer"
                  type="text"
                  class="form-control"
                  id="vatCode"
                  formControlName="vatCode"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.vatCode')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.vatCode')"></wsb-validation-error-msg>
              </div>
            </div>
            <!-- oninput="this.value = this.value.toUpperCase()" -->
            <div class="form-group row" *ngIf="user.nation === 'ita'">
              <label for="taxCode" class="col-sm-4" translate>account_cf</label>
              <div class="col-sm-8">
                <input
                  [readonly]="user.account.isCustomer"
                  type="text"
                  class="form-control"
                  id="taxCode"
                  formControlName="taxCode"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.taxCode')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.taxCode')"></wsb-validation-error-msg>
              </div>
            </div>
            <div class="form-group row">
              <label for="address" class="col-sm-4" translate>account_address</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="address"
                  formControlName="address"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.address')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.address')"></wsb-validation-error-msg>
              </div>
            </div>
            <div class="form-group row">
              <label for="zipCode" class="col-sm-4" translate>account_zip</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="zipCode"
                  formControlName="zipCode"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.zipCode')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.zipCode')"></wsb-validation-error-msg>
              </div>
            </div>
            <div class="form-group row">
              <label for="city" class="col-sm-4" translate>account_city</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="city"
                  formControlName="city"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.city')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.city')"></wsb-validation-error-msg>
              </div>
            </div>
            <div class="form-group row" *ngIf="user.nation === 'ita'">
              <label for="province" class="col-sm-4" translate>account_province</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="province"
                  formControlName="province"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.province')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.province')"></wsb-validation-error-msg>
              </div>
            </div>
            <div class="form-group row">
              <label for="invoicingEmail" class="col-sm-4" translate>account_invoicing_email</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="invoicingEmail"
                  formControlName="invoicingEmail"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.invoicingEmail')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.invoicingEmail')"></wsb-validation-error-msg>
                <small class="form-text text-muted" translate>settings_account_invoicing_email_help</small>
              </div>
            </div>
            <div class="form-group row" *ngIf="user.nation === 'ita'">
              <label for="paCode" class="col-sm-4" translate>settings_account_codice_pa</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  id="paCode"
                  formControlName="paCode"
                  wsbAppControlValidator
                  [fc]="billingForm.get('billing.paCode')"
                />
                <wsb-validation-error-msg [fc]="billingForm.get('billing.paCode')"></wsb-validation-error-msg>
                <small class="form-text text-muted" translate>settings_account_codice_pa_help</small>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="page__actions  actions-bar" #actionsBar style="z-index: 1">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button #submitBtn class="btn btn-primary btn-sm" (click)="submitBillingForm()" translate>common_save</button>
          <button #submitBtn (click)="goBack()" class="btn  btn-secondary ms-3 btn-sm" translate>common_back</button>
          <button *ngIf="billingForm.dirty" type="button" class="btn btn-link btn-sm ms-4" (click)="resetForm()" translate>
            common_cancel
          </button>
        </div>
        <div *ngIf="!billingForm.pristine" class="mt-2">
          <span [inlineSVG]="'assets/images/icons/icon-info.svg'" class="info-icon  me-1"></span>
          <small translate>common_unsaved_changes</small>
        </div>
      </div>
    </div>
  </div>
</div>
